// extracted by mini-css-extract-plugin
export default {"courses":"Courses_courses__HHwYY","items":"Courses_items__T5xAW","invalid":"Courses_invalid__uibhr"};